import "./main-banner.css"
import logo from "../../../assets/imgs/navbar/Logo-AMC-blanco.png";
import imgBanner from "../../../assets/imgs/dashboard-admin/img-airplane2.png"


function MainBanner () {
  return (
    <div className="bg-admin">
        <div 
          className="bg-admin-gradient d-flex" 
          style={{ 
            backgroundImage: `linear-gradient(90.21deg, rgba(2, 12, 65, 0) 0.03%, rgba(2, 12, 65, 0.75) 100%), url(${imgBanner})` 
          }}
        >
            <div className="pe-4 align-self-center">
                <img className="logo-amc-admin" src={logo} alt="logo amc"/>
            </div>
        </div>
    </div>
  )
}

export default MainBanner